import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { DataGrid, GridRowSelectionModel } from "@mui/x-data-grid"
import React from "react"
import { OptionsType } from "../../store/types/MissionsTypes"
import { LoadingButton } from "../LoadingButton/LoadingButton"
import { nexDefaultPagination, nexPageSizes } from "../Table/pageable-table/NexPageSize"
import { AlertModalProps } from "./AlertModal"
import { useStyles } from "./styles"

interface DataGridModalProps extends AlertModalProps {
    columns: any[]
    rows: OptionsType[]
    selected: GridRowSelectionModel
    onSelectionChange: (model: GridRowSelectionModel) => void
    additionalActions?: React.ReactNode
    isRowSelectableFunct?: (params: any) => boolean
}

export const DataGridModal = ({
    children,
    confirmText,
    danger,
    title,
    onClose,
    onConfirm,
    open,
    pending,
    columns,
    rows,
    selected,
    onSelectionChange,
    additionalActions,
    isRowSelectableFunct,
}: DataGridModalProps) => {
    const { classes, cx } = useStyles()

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle>{title}</DialogTitle>
            {children && (
                <DialogContent>
                    <DialogContentText>{children}</DialogContentText>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{
                            pagination: { paginationModel: { pageSize: nexDefaultPagination.pageSize } },
                        }}
                        pageSizeOptions={nexPageSizes}
                        checkboxSelection
                        disableRowSelectionOnClick={true}
                        disableRowSelectionExcludeModel={true}
                        rowSelectionModel={selected}
                        onRowSelectionModelChange={onSelectionChange}
                        isRowSelectable={isRowSelectableFunct}
                        sx={{ height: 450 }}
                    />
                </DialogContent>
            )}
            <DialogActions>
                {additionalActions}
                <LoadingButton
                    pending={pending}
                    color="primary"
                    className={cx({ [classes.btn_delete]: danger })}
                    variant="outlined"
                    onClick={onConfirm}
                >
                    {confirmText}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
